// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autorization_mainWrapper__mVzvn {
  height: -moz-fit-content;
  height: fit-content;
  padding: 0 10px;
}

.autorization_wrapperTooltip__8Mk58.autorization_wrapperTooltip__8Mk58 {
  background-color: transparent;
  padding: 0;
}

.autorization_tooltip__SCnRl.autorization_tooltip__SCnRl {
  background-color: #fff;
  border-radius: 8px;
}

.autorization_tooltip__SCnRl.autorization_tooltip__SCnRl span {
  color: var(--color-black-500, #577487);
}

.autorization_tooltip__SCnRl.autorization_tooltip__SCnRl button span {
  color: var(--color-black-main, #364954);
}

.autorization_tooltip__SCnRl.autorization_tooltip__SCnRl button:hover {
  background-color: #45dcc6;
}

.autorization_tooltip__SCnRl.autorization_tooltip__SCnRl button:active {
  background-color: #0c6154;
}

.autorization_tooltip__SCnRl.autorization_tooltip__SCnRl button:active span {
  color: #fff;
}

.autorization_lngButton__3TCWC {
  color: #678aa1;
}

.autorization_lngActive__8prTp {
  color: #55bbeb;
}

.autorization_tooltipWrapper__3Htjs {
  position: relative;
  display: inline-block;
  cursor: pointer; 
}

.autorization_tooltipText__2BOj3 {
  visibility: hidden; 
  width: 150px;
  background-color: rgba(0, 0, 0, 0.75); 
  color: #fff; 
  text-align: center;
  border-radius: 4px; 
  padding: 5px 10px; 
  position: absolute;
  z-index: 10000 !important; 
  bottom: 125%; 
  left: 50%;
  transform: translateX(-50%);
  opacity: 0; 
  transition: opacity 0.3s ease-in-out;
  font-size: 12px;
  pointer-events: none; 
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); 
}

.autorization_tooltipWrapper__3Htjs:hover .autorization_tooltipText__2BOj3 {
  visibility: visible;
  opacity: 1;
  position: absolute;
}

.autorization_errorIcon__CYu1w {
  color: red; /* Цвет иконки */
  width: 16px; /* Размер иконки */
  height: 13px;
  display: inline-block;
}


.autorization_inputField__qaQg2 {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  width: 100%;
  min-width: 150px;
}


.autorization_formWrapper__uKGa0 {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow-y: scroll;
}

.autorization_registrationTitle__e3CAp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 24px;
  max-width: 1080px;
}

.autorization_registrationConfigRoot__sr871 {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.autorization_labelAndButtonWrapper__pbbup {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  gap: 10px;
}

.autorization_titleWrapper__ZuB8y {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.autorization_checkboxWraper__CNcdc {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  gap: 8px;
}

.autorization_labelCheckBox__USzVw {
  font-size: 14px;
  font-weight: 500;
}

.autorization_labelAndErrorWrapper__ylLum {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
}

.autorization_orgTitleMain__t0M6o {
  font-weight: 600;
}

@media screen and (max-width: 600px) {
  .autorization_label-and-error-wrapper__58kqj {
    margin-top: 10px;
  }
}

.autorization_subjectBlockConfigRoot__qv1Nb {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  margin-bottom: 12px;
}

.autorization_blockConfigRoot__cXLLS {
  background-color: #fff;
  border-radius: 8px;
  padding: 8px 24px;
  gap: 10px;
  width: 100%;
  max-width: 1080px;
}

.autorization_buttonBlock__wIil6 {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  max-width: 100%;
  margin-bottom: 16px;
}

.autorization_buttonConfigRoot__XQcEH {
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.autorization_formAddButton__G7dZ1 {
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.autorization_formAddButton__G7dZ1 span {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}

.autorization_formAddButton__G7dZ1 img {
  flex-shrink: 0;
}

.autorization_formAddButton__G7dZ1:hover {
  background-color: #f3f7f7;
}

.autorization_formButton__5L4C0 {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  gap: 8px;
}

.autorization_inputField__qaQg2 {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(33% - 8px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  width: 100%;
  min-width: 150px;
}

.autorization_inputField1__2HPPP {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  /* max-width: calc(50% - 8px); */
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 10px);
  width: 100%;
  min-width: 150px;
}

.autorization_inputField2__fzaz0 {
  /* max-width: 256px; */
  /* flex: 1 1 calc(50% - 10px); */
  max-width: calc(33% - 8px);
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  color: #2e3138;
  margin-bottom: 8px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  width: 100%;
  overflow: hidden;
  min-width: 150px;
}

.autorization_inputFieldNoOwerflow__4Veiu {
  overflow: visible;
}

.autorization_inputField1__2HPPP .autorization_placeholder__WTBO4,
.autorization_inputField1__2HPPP input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 14px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}

.autorization_inputField2__fzaz0 .autorization_placeholder__WTBO4,
.autorization_inputField2__fzaz0 input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 14px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}

.autorization_selectField__ZhN8N {
  width: 100%;
  height: 48px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  padding: 8px;
  margin: 0;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
}

.autorization_inputField__qaQg2 .autorization_placeholder__WTBO4,
.autorization_inputField__qaQg2 input {
  width: 100%;
  height: 40px;
  border: 1px solid #a3c0d2;
  border-radius: 10px;
  padding-left: 10px;
  font-size: 12px;
  color: #2e3138;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  line-height: 19.6px;
  margin: 0;
  outline: none;
}

.autorization_inputField__qaQg2 input:hover {
  border-color: #8ea3b0;
}

.autorization_inputField__qaQg2 input:focus {
  border-color: #0c6154;
  border-width: 1px;
}

.autorization_inputField__qaQg2 input::placeholder {
  color: #a3c0d2;
  font-weight: 400;
  font-size: 14px;
}

.autorization_inputField__qaQg2 input.autorization_-error__UPGf7 {
  border-color: #ed1e1e;
}

.autorization_inputField1__2HPPP input:hover {
  border-color: #8ea3b0;
}

.autorization_inputField1__2HPPP input:focus {
  border-color: #0c6154;
  border-width: 1px;
}

.autorization_inputField1__2HPPP input::placeholder {
  color: #a3c0d2;
  font-weight: 400;
  font-size: 14px;
}

.autorization_inputField2__fzaz0 input.autorization_-error__UPGf7 {
  border-color: #ed1e1e;
}

.autorization_inputField2__fzaz0 input:hover {
  border-color: #8ea3b0;
}

.autorization_inputField2__fzaz0 input:focus {
  border-color: #0c6154;
  border-width: 1px;
}

.autorization_inputField2__fzaz0 input::placeholder {
  color: #a3c0d2;
  font-weight: 400;
  font-size: 14px;
}

.autorization_inputField2__fzaz0 input.autorization_-error__UPGf7 {
  border-color: #ed1e1e;
}

.autorization_buttonForm__1O2YL {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 8px);
}

.autorization_errorLabel__xAKwo {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: rgb(249, 52, 30);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.autorization_labelAndErrorWrapper__ylLum {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  align-items: center;
}

.autorization_modalHeader__dhxU1{
  display:flex;
  flex-direction: column;
  width:100%;
  padding:20px;
  min-width:500px;
  gap:20px;
}
.autorization_modalTitle__kAhiF{
  font-size: 12px;
  font-family: Inter;
}
.autorization_modalDesc__ehFgs{
  font-size: 12px;
  font-family: Inter;
  font-weight: 400;
  max-width: 500px;
}
.autorization_HorLine__mCkhv{
  width:100%;
  background-color: #d1d1d1;
  padding:4px 0px 0px 0px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Authorization/autorization.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU,EAAE,gBAAgB;EAC5B,WAAW,EAAE,kBAAkB;EAC/B,YAAY;EACZ,qBAAqB;AACvB;;;AAGA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":[".mainWrapper {\n  height: fit-content;\n  padding: 0 10px;\n}\n\n.wrapperTooltip.wrapperTooltip {\n  background-color: transparent;\n  padding: 0;\n}\n\n.tooltip.tooltip {\n  background-color: #fff;\n  border-radius: 8px;\n}\n\n.tooltip.tooltip span {\n  color: var(--color-black-500, #577487);\n}\n\n.tooltip.tooltip button span {\n  color: var(--color-black-main, #364954);\n}\n\n.tooltip.tooltip button:hover {\n  background-color: #45dcc6;\n}\n\n.tooltip.tooltip button:active {\n  background-color: #0c6154;\n}\n\n.tooltip.tooltip button:active span {\n  color: #fff;\n}\n\n.lngButton {\n  color: #678aa1;\n}\n\n.lngActive {\n  color: #55bbeb;\n}\n\n.tooltipWrapper {\n  position: relative;\n  display: inline-block;\n  cursor: pointer; \n}\n\n.tooltipText {\n  visibility: hidden; \n  width: 150px;\n  background-color: rgba(0, 0, 0, 0.75); \n  color: #fff; \n  text-align: center;\n  border-radius: 4px; \n  padding: 5px 10px; \n  position: absolute;\n  z-index: 10000 !important; \n  bottom: 125%; \n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0; \n  transition: opacity 0.3s ease-in-out;\n  font-size: 12px;\n  pointer-events: none; \n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); \n}\n\n.tooltipWrapper:hover .tooltipText {\n  visibility: visible;\n  opacity: 1;\n  position: absolute;\n}\n\n.errorIcon {\n  color: red; /* Цвет иконки */\n  width: 16px; /* Размер иконки */\n  height: 13px;\n  display: inline-block;\n}\n\n\n.inputField {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  width: 100%;\n  min-width: 150px;\n}\n\n\n.formWrapper {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  overflow-y: scroll;\n}\n\n.registrationTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 24px;\n  max-width: 1080px;\n}\n\n.registrationConfigRoot {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n}\n\n.labelAndButtonWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2px;\n  gap: 10px;\n}\n\n.titleWrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.checkboxWraper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  gap: 8px;\n}\n\n.labelCheckBox {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.labelAndErrorWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n}\n\n.orgTitleMain {\n  font-weight: 600;\n}\n\n@media screen and (max-width: 600px) {\n  .label-and-error-wrapper {\n    margin-top: 10px;\n  }\n}\n\n.subjectBlockConfigRoot {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n  margin-bottom: 12px;\n}\n\n.blockConfigRoot {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 8px 24px;\n  gap: 10px;\n  width: 100%;\n  max-width: 1080px;\n}\n\n.buttonBlock {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  max-width: 100%;\n  margin-bottom: 16px;\n}\n\n.buttonConfigRoot {\n  background-color: #fff;\n  border-radius: 8px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.formAddButton {\n  background-color: #fff;\n  width: 100%;\n  border-radius: 8px;\n  padding: 10px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.formAddButton span {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n  overflow: hidden;\n}\n\n.formAddButton img {\n  flex-shrink: 0;\n}\n\n.formAddButton:hover {\n  background-color: #f3f7f7;\n}\n\n.formButton {\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n  gap: 8px;\n}\n\n.inputField {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(33% - 8px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  flex: 1 1 calc(50% - 10px);\n  width: 100%;\n  min-width: 150px;\n}\n\n.inputField1 {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  /* max-width: calc(50% - 8px); */\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  flex: 1 1 calc(33% - 10px);\n  width: 100%;\n  min-width: 150px;\n}\n\n.inputField2 {\n  /* max-width: 256px; */\n  /* flex: 1 1 calc(50% - 10px); */\n  max-width: calc(33% - 8px);\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  color: #2e3138;\n  margin-bottom: 8px;\n  flex: 1 1 calc(50% - 10px);\n  width: 100%;\n  overflow: hidden;\n  min-width: 150px;\n}\n\n.inputFieldNoOwerflow {\n  overflow: visible;\n}\n\n.inputField1 .placeholder,\n.inputField1 input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 14px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n\n.inputField2 .placeholder,\n.inputField2 input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 14px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n\n.selectField {\n  width: 100%;\n  height: 48px;\n  flex: 1 1 calc(50% - 10px);\n  padding: 8px;\n  margin: 0;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n}\n\n.inputField .placeholder,\n.inputField input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #a3c0d2;\n  border-radius: 10px;\n  padding-left: 10px;\n  font-size: 12px;\n  color: #2e3138;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  line-height: 19.6px;\n  margin: 0;\n  outline: none;\n}\n\n.inputField input:hover {\n  border-color: #8ea3b0;\n}\n\n.inputField input:focus {\n  border-color: #0c6154;\n  border-width: 1px;\n}\n\n.inputField input::placeholder {\n  color: #a3c0d2;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.inputField input.-error {\n  border-color: #ed1e1e;\n}\n\n.inputField1 input:hover {\n  border-color: #8ea3b0;\n}\n\n.inputField1 input:focus {\n  border-color: #0c6154;\n  border-width: 1px;\n}\n\n.inputField1 input::placeholder {\n  color: #a3c0d2;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.inputField2 input.-error {\n  border-color: #ed1e1e;\n}\n\n.inputField2 input:hover {\n  border-color: #8ea3b0;\n}\n\n.inputField2 input:focus {\n  border-color: #0c6154;\n  border-width: 1px;\n}\n\n.inputField2 input::placeholder {\n  color: #a3c0d2;\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.inputField2 input.-error {\n  border-color: #ed1e1e;\n}\n\n.buttonForm {\n  flex: 1 1 calc(33% - 8px);\n}\n\n.errorLabel {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n  color: rgb(249, 52, 30);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.labelAndErrorWrapper {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n  align-items: center;\n}\n\n.modalHeader{\n  display:flex;\n  flex-direction: column;\n  width:100%;\n  padding:20px;\n  min-width:500px;\n  gap:20px;\n}\n.modalTitle{\n  font-size: 12px;\n  font-family: Inter;\n}\n.modalDesc{\n  font-size: 12px;\n  font-family: Inter;\n  font-weight: 400;\n  max-width: 500px;\n}\n.HorLine{\n  width:100%;\n  background-color: #d1d1d1;\n  padding:4px 0px 0px 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainWrapper": `autorization_mainWrapper__mVzvn`,
	"wrapperTooltip": `autorization_wrapperTooltip__8Mk58`,
	"tooltip": `autorization_tooltip__SCnRl`,
	"lngButton": `autorization_lngButton__3TCWC`,
	"lngActive": `autorization_lngActive__8prTp`,
	"tooltipWrapper": `autorization_tooltipWrapper__3Htjs`,
	"tooltipText": `autorization_tooltipText__2BOj3`,
	"errorIcon": `autorization_errorIcon__CYu1w`,
	"inputField": `autorization_inputField__qaQg2`,
	"formWrapper": `autorization_formWrapper__uKGa0`,
	"registrationTitle": `autorization_registrationTitle__e3CAp`,
	"registrationConfigRoot": `autorization_registrationConfigRoot__sr871`,
	"labelAndButtonWrapper": `autorization_labelAndButtonWrapper__pbbup`,
	"titleWrapper": `autorization_titleWrapper__ZuB8y`,
	"checkboxWraper": `autorization_checkboxWraper__CNcdc`,
	"labelCheckBox": `autorization_labelCheckBox__USzVw`,
	"labelAndErrorWrapper": `autorization_labelAndErrorWrapper__ylLum`,
	"orgTitleMain": `autorization_orgTitleMain__t0M6o`,
	"label-and-error-wrapper": `autorization_label-and-error-wrapper__58kqj`,
	"subjectBlockConfigRoot": `autorization_subjectBlockConfigRoot__qv1Nb`,
	"blockConfigRoot": `autorization_blockConfigRoot__cXLLS`,
	"buttonBlock": `autorization_buttonBlock__wIil6`,
	"buttonConfigRoot": `autorization_buttonConfigRoot__XQcEH`,
	"formAddButton": `autorization_formAddButton__G7dZ1`,
	"formButton": `autorization_formButton__5L4C0`,
	"inputField1": `autorization_inputField1__2HPPP`,
	"inputField2": `autorization_inputField2__fzaz0`,
	"inputFieldNoOwerflow": `autorization_inputFieldNoOwerflow__4Veiu`,
	"placeholder": `autorization_placeholder__WTBO4`,
	"selectField": `autorization_selectField__ZhN8N`,
	"-error": `autorization_-error__UPGf7`,
	"buttonForm": `autorization_buttonForm__1O2YL`,
	"errorLabel": `autorization_errorLabel__xAKwo`,
	"modalHeader": `autorization_modalHeader__dhxU1`,
	"modalTitle": `autorization_modalTitle__kAhiF`,
	"modalDesc": `autorization_modalDesc__ehFgs`,
	"HorLine": `autorization_HorLine__mCkhv`
};
export default ___CSS_LOADER_EXPORT___;
